import { MinMax } from './MinMax';

export interface IFilter {
    Price: MinMax;
    Beds: MinMax;
    Baths: MinMax;
    Mla: MinMax;
    Tla: MinMax;
    LotSize: MinMax;
    Age: MinMax;
    Type: any; // {"Value":[]},
    Style: any; // {"Value":[]},
    Class: any; // {"Value":[]},
    Status: any; // {"Value":[]},
    HeatType: any; // {"Value":[]}
    Waterfront: any; // {"Value":null}
    Garage: any; // {"Value":null}
    SchoolCatchmentId: any; // {"Value":null}
}

export class Filter implements IFilter {
    public Price: MinMax;
    public Beds: MinMax;
    public Baths: MinMax;
    public Mla: MinMax;
    public Tla: MinMax;
    public LotSize: MinMax;
    public Age: MinMax;
    public Type: any; // {"Value":[]},
    public Style: any; // {"Value":[]},
    public Class: any; // {"Value":[]},
    public Status: any; // {"Value":[]},
    public HeatType: any; // {"Value":[]}
    public Waterfront: any; // {"Value":null}
    public Garage: any; // {"Value":null}
    public SchoolCatchmentId: any; // {"Value":null}
    constructor(
        filterProps: any,
    ) {
        this.Price = new MinMax(filterProps.price);
        this.Beds = new MinMax(filterProps.beds);
        this.Baths = new MinMax(filterProps.baths);
        this.Mla = new MinMax(filterProps.mla);
        this.Tla = new MinMax(filterProps.tla);
        this.LotSize = new MinMax(filterProps.lotSize);
        this.Age = new MinMax(filterProps.age);
        this.Type = filterProps.type; // {"Value":[]},
        this.Style = filterProps.style; // {"Value":[]},
        this.Class = filterProps.class; // {"Value":[]},
        this.Status = filterProps.status; // {"Value":[]},
        this.HeatType = filterProps.heatType; // {"Value":[]}
        this.Waterfront = filterProps.waterfront; // {"Value":null}
        this.Garage = filterProps.garage; // {"Value":null}
        this.SchoolCatchmentId = filterProps.schoolCatchmentId ? filterProps.schoolCatchmentId : { value: null }; // {"Value":null}
    }
    public toJson() {
        return {
            price: { min: this.Price.Min, max: this.Price.Max },
            beds: { min: this.Beds.Min, max: this.Beds.Max },
            baths: { min: this.Baths.Min, max: this.Baths.Max },
            mla: { min: this.Mla.Min, max: this.Mla.Max },
            tla: { min: this.Tla.Min, max: this.Tla.Max },
            lotSize: { min: this.LotSize.Min, max: this.LotSize.Max },
            age: { min: this.Age.Min, max: this.Age.Max },
            type: this.Type,
            style: this.Style,
            class: this.Class,
            status: this.Status,
            heatType: this.HeatType,
            waterfront: this.Waterfront,
            garage: this.Garage,
            schoolCatchmentId: this.SchoolCatchmentId,
        };
    }
}





